import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { motion } from "framer-motion";
import { useMutation } from "@apollo/react-hooks";
import dateFormat from "dateformat";
import uniqid from "uniqid";

import Layout from "./Layout";
import { Redirect } from "react-router-dom";
import { isLoggedIn, getUser, deleteUser } from "./../lib/session";
import { TRACK_ACTIVITY } from "./../lib/graphqlQueries";

import ControlGroup from "../templates/ControlGroup";
import Login from "../templates/Login";
import Profile from "../templates/Profile";
import Library from "../templates/Library";
import Video from "../templates/Video";
import libraryIcon from "./../assets/library-outline.svg";
import libraryIconSelected from "./../assets/library-selected.svg";
import profileIcon from "./../assets/profile-outline.svg";
import profileIconSelected from "./../assets/profile-selected.svg";

const transitionVariants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 }
};

const PageContainer = ({ currentBackground }) => {
  const [trackActivity] = useMutation(TRACK_ACTIVITY);
  const user = getUser();
  const { home, type } = user || {};

  const track = async (
    action,
    value,
    callback = () => {},
    errorCallback = () => {}
  ) => {
    try {
      const now = new Date();
      const mutationId = uniqid();
      const response = await trackActivity({
        variables: {
          action,
          actionDate: dateFormat(now, "yyyy-mm-dd HH:MM:ss"),
          actionValue: value,
          mutationId
        },
        errorPolicy: "all"
      });
      callback(response);
    } catch (error) {
      errorCallback(error);
    }
  };

  const routeList = [
    {
      path: "/",
      component: Login,
      title: "Login",
      type: "login",
      noNav: true
    },
    {
      path: "/control",
      component: ControlGroup,
      title: "Control",
      type: "private",
      noNav: true
    },
    {
      path: "/videos/:id",
      component: Video,
      title: "Video",
      type: "private",
      noNav: type !== "medical"
    },
    {
      path: "/library",
      component: Library,
      title: "My Library",
      icons: {
        icon: libraryIcon,
        selectedIcon: libraryIconSelected
      },
      extraProps: {
        badge: null
      },
      type: "private",
      noNav: type !== "medical"
    },
    {
      path: "/profile",
      component: Profile,
      title: "My Profile",
      icons: {
        icon: profileIcon,
        selectedIcon: profileIconSelected
      },
      extraProps: {
        dot: false
      },
      type: "private",
      noNav: type !== "medical"
    }
  ];

  return routeList.map(route => {
    return (
      <Route
        exact
        path={route.path}
        key={route.path}
        render={props => {
          if (route.type === "private" && !isLoggedIn()) {
            return <Redirect to="/" />;
          } else if (route.type === "login" && isLoggedIn()) {
            return <Redirect to={home} />;
          }

          return (
            <Layout
              routeList={routeList}
              {...route}
              currentBackground={currentBackground}
            >
              <div className="app">
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  transition={{
                    ease: "easeOut",
                    duration: 1
                  }}
                  variants={transitionVariants}
                >
                  <route.component {...props} {...route} track={track} />
                </motion.div>
              </div>
            </Layout>
          );
        }}
      />
    );
  });
};

export default PageContainer;
